import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import createPaginationControl from "../../Common/createPaginationControl";
import Excel from "../../Common/Excel";
import PrintOut from "../../Common/PrintOut";
import Spinner from "../../Common/Spinner";
import NavigationBarContainer from "../NavigationBarContainer";
import FilterContainer from "./FilterContainer";
import List from "./List";

import {
    getIleggelseList,
    getIleggelserForOversikt,
    getIleggelserInExcelFormat,
} from "../../../selectors/ileggelserSelector";

import { getIleggelser as getIleggelserAction } from "../../../actions/ileggelserActions";
import { getOvertredelserkoderIleggelser as getOvertredelserkoderIleggelserAction } from "../../../actions/overtredelseskoderIleggelserActions";

import { juridiskAll } from "../../../constants/roles";
import sitePaths from "../../../constants/sitePaths";
import * as title from "../../../constants/titles";
import { authorized } from "../../../utils/authorizationUtils";
import "./IleggelserOversiktContainer.css";

const PaginationControl = createPaginationControl(
  "ileggelser",
  {
    apiCallAction: getIleggelserAction,
    queriesForApiReducerName: "forms.ileggelserOversiktFilterForm",
  },
  getIleggelseList,
);

export default function OversiktContainer() {
  const dispatch = useDispatch();
  const ileggelser = useSelector(getIleggelserForOversikt);
  const ileggelserOversiktFilterForm = useSelector(
    (state) => state.forms.ileggelserOversiktFilterForm,
  );
  const ileggelserInExcelFormat = useSelector(getIleggelserInExcelFormat);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    document.title = title.ileggelse.ileggelsesoversikt;
    dispatch(getOvertredelserkoderIleggelserAction());
  }, []);

  return (
    <>
      <>
        <NavigationBarContainer page="oversikt" />
        <FilterContainer />
        <div style={{ height: 28 }} />
        {ileggelser.items.length !== 0 && (
          <React.Fragment>
            <div style={{ marginLeft: 50 }}>
              <div className="pull-left">
                {!authorized(juridiskAll) && (
                  <div style={{ display: "inline-block", marginRight: 10 }}>
                    <PrintOut
                      url={`${window.location.origin}${sitePaths.ileggelser.oversikt.utskrift}`}
                      dataToStoreInSessionStorage={{
                        queryData: {
                          ...ileggelserOversiktFilterForm,
                        },
                        paginationData: {
                          page: ileggelser.page,
                          count: ileggelser.count,
                        },
                      }}
                    />
                  </div>
                )}
                <Excel
                  element={(onClick) => (
                    <button
                      className="btn btn-bym-medium btn-bym-action"
                      onClick={onClick}
                    >
                      Lag rapport
                    </button>
                  )}
                  filename="Ileggelser.xlsx"
                  sheets={ileggelserInExcelFormat}
                  total={ileggelser.total}
                  count={ileggelser.count}
                />
              </div>
              <div
                className="pull-right ileggelse-list-page-total-ileggelser"
                style={{ paddingTop: 20, paddingRight: 50 }}
              >
                {ileggelser.total} ileggelser
              </div>
            </div>
            <div className="clearfix" />
            <div style={{ height: 22 }} />
            <div style={{ paddingRight: 50, paddingLeft: 50 }}>
              <div
                id="ileggelse-list-page-content-container"
                className="ileggelse-list-page-content-container"
              >
                <List ileggelser={ileggelser.items} />
              </div>
              <PaginationControl storeKey="ileggelser" />
              <div className="clearfix" />
            </div>
          </React.Fragment>
        )}
        <Spinner isLoading={ileggelser.isFetching} />
        <div style={{ height: 50 }} />
      </>
    </>
  );
}
